// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');

  return token ? children : <Navigate to="/signin" />;
};

export default PrivateRoute;
